module.exports = __webpack_public_path__ + "static/media/comserv_graphic.c163f51a.webp";